<template>
  <div>
    <mds-list-group>
      <mds-list-group-item
        :collapsible="menu.isSubMenuExists"
        :expanded="menu.isExpanded"
        :active="menu.isActive && !menu.isSubMenuExists"
        @click.native="
          menu.isExpanded = !menu.isExpanded;
          onClickMenu(sectionId, menu.id, menu.isSubMenuExists);
        "
        v-for="menu in menuList"
        :text="menu.name"
      >
        <template #mds-list-item-children>
          <adl-sub-menu
            :sectionId="sectionId"
            :menuId="menu.id"
            :subMenus="subMenus"
            @onClick="onClickSubMenu"
          ></adl-sub-menu>
        </template>
      </mds-list-group-item>
    </mds-list-group>
  </div>
</template>
<script>
import { MdsListGroup, MdsListGroupItem } from "@mds/list-group";
import AdlSubMenu from "./subMenu.vue";
export default {
  inheritAttrs: false,

  props: {
    sectionId: { type: Number },
    menus: {
      type: Array,
    },
    subMenus: {
      type: Array,
    },
  },
  components: {
    MdsListGroupItem,
    MdsListGroup,
    AdlSubMenu,
  },

  data() {
    return {};
  },
  computed: {
    menuList() {
      let menu = [];
      menu = this.menus.filter((sr) => sr.sectionId == this.sectionId);
      if (menu.length > 0) {
        for (let i = 0; i < menu.length; i++) {
          let isSubMenuExists = this.subMenus.findIndex(
            (sr) => sr.menuId == menu[i].id
          );
          menu[i].isSubMenuExists = isSubMenuExists >= 0 ? true : false;
        }
      }
      return menu;
    },
  },

  async created() {},
  methods: {
    onClickSubMenu(sectionId, menuId, submenuId) {
      this.$emit("onClick", sectionId, menuId, submenuId);
    },
    onClickMenu(sectionId, menuId, isSubMenuExists) {
      let submenuId = 0;
      if (isSubMenuExists) {
        let subMenu = this.subMenus.filter(
          (sr) => sr.menuId == menuId && sr.sectionId == sectionId
        );
        if (subMenu.length > 0) submenuId = subMenu[0].id;
      }
      this.$emit("onClick", sectionId, menuId, submenuId);
    },
  },
};
</script>
